import React from 'react'
import VariablesContextProvider from '../contexts/variablesContext'
import LegalNoticesTable from './Table'

interface Props {
  providerKey: string
}

const ProviderTable = ({ providerKey }: Props): JSX.Element => (
  <VariablesContextProvider providerKey={providerKey}>
    <LegalNoticesTable providerKey={providerKey} />
  </VariablesContextProvider>
)

export default ProviderTable
